import angular from 'angular';

export default function AddReportPackageDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  orgDataService,
  reportsDataService,
  loaderService,
  editReportPackageDialog,
  selectEditTypeDialog,
  ssDialogService
) {
  const vm = this;

  vm.handleCloseDialog = handleCloseDialog;
  vm.handleAddReportPackageFormSubmit = handleAddReportPackageFormSubmit;

  vm.isValidControl = isValidControl;
  vm.documentAttached = _documentAttached;

  _initEventListeners();

  _activate();

  /** *********************************************
   * Event Handlers
   */

  function handleCloseDialog() {
    _closeDialog();
  }

  function handleAddReportPackageFormSubmit() {
    console.log(`handleAddReportPackageFormSubmit: scope.valid: ${$scope.prAddReportPackageForm.$valid}`);
    if ($scope.prAddReportPackageForm.$valid) {
      loaderService.showViewLoader = true;
      _saveReportPackage().then(() => {
        loaderService.showViewLoader = false;
      });
    }
  }

  function isValidControl(ctrl) {
    return ($scope.prAddReportPackageForm)
      && (($scope.prAddReportPackageForm.$submitted && ctrl.$invalid) || (ctrl.$dirty && ctrl.$invalid));
  }

  /** *********************************************
   * Private Functions
   */

  function _activate() {
    loaderService.showViewLoader = false;
  }

  function _initEventListeners() {
    $scope.$on('closeAddReportPackage', () => { _closeDialog(); });
  }

  function _saveReportPackage($event) {
    const dfdSave = $q.defer();
    const dfdHideDialog = $q.defer();

    if (_isValid()) {
      reportsDataService.saveReportPackage(vm.reportPackage).then((response) => {
        const savedReportPackage = response.data;
        if (savedReportPackage.reportPackageId === 'undefined' || savedReportPackage.reportPackageId <= 0) {
          // There was an error saving the Report Package information
          alerts.error('Error occurred while saving the Report Package.');
          dfdSave.reject();
        } else {
          // The reportPackage information has been saved
          vm.reportPackage = savedReportPackage;
          // alerts.success('The Report Package has been saved successfully.');
          ssDialogService.hide(ssDialogService.dialogs.reports.addReportPackageDialog).then(() => {
            if (vm.usesUpdatedReportPackaging) {
              _showSelectEditTypeDialog($event).then(() => {
                dfdHideDialog.resolve();
              });
            } else {
              _showEditReportPackageDialog($event).then(() => {
                dfdHideDialog.resolve();
              });
            }
          });
        }
        $rootScope.$broadcast('refreshReportPackages');
      });

      dfdHideDialog.promise.then(dfdSave.resolve);
    } else {
      dfdSave.reject();
    }
    return dfdSave.promise;
  }

  function _isValid() {
    let isValid = $scope.prAddReportPackageForm.$valid;

    if (!isValid) {
      isValid = true;
      angular.forEach($scope.prAddReportPackageForm.$error.parse, () => {
        isValid = false;
      });
      angular.forEach($scope.prAddReportPackageForm.$error.pattern, () => {
        isValid = false;
      });
      angular.forEach($scope.prAddReportPackageForm.$error.required, () => {
        isValid = false;
      });
    }
    return isValid;
  }

  function _showEditReportPackageDialog($event) {
    ssDialogService.dialogs.reports.editReportPackageDialog = ssDialogService.alert(
      editReportPackageDialog.getOptions($event, {
        reportPackage: vm.reportPackage,
      }),
    );
    return ssDialogService.show(ssDialogService.dialogs.reports.editReportPackageDialog);
  }

  function _showSelectEditTypeDialog($event) {  

    let hasAdvisoryServices = false;
    
    return orgDataService.getCustomerServices(vm.customerId).then(response => {

      const services = response.data.result;
      
      angular.forEach(services, (item) => {
        if ((item.serviceId === 9) || (item.serviceId === 10) || (item.serviceId === 23) || (item.serviceId === 29)) {
          hasAdvisoryServices = true;
        }
      });

      ssDialogService.dialogs.reports.selectEditTypeDialog = ssDialogService.alert(
        selectEditTypeDialog.getOptions($event, {
          hasAdvisoryServices,
          customerId: vm.customerId,
          reportPackage: vm.reportPackage,
          selectedEditTypeId: 1,
        }),
      );

      return ssDialogService.show(ssDialogService.dialogs.reports.selectEditTypeDialog);
    });
  }

  function _documentAttached() {
    $rootScope.$broadcast('refreshReportPackage', { reportPackageId: vm.reportPackage.reportPackageId });
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.reports.addReportPackageDialog);
  }
}

AddReportPackageDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'orgDataService',
  'reportsDataService',
  'loaderService',
  'editReportPackageDialog',
  'selectEditTypeDialog',
  'ssDialogService'
];
